class Transaction {
  constructor(itemDetails) {
    this.grossAmount = itemDetails.reduce((sum, item) => sum + item.price * item.quantity, 0);
    this.itemDetails = itemDetails;
  }

  toJSON() {
    return {
      gross_amount: this.grossAmount,
      item_details: this.itemDetails
    };
  };
}

export default Transaction;
